module.exports = __webpack_public_path__ + "static/img/cus_16_pre.67b70f93.jpg";